import { useEffect, useState } from "react";
import { http } from "../../../axios/axios";
import { GetImageUrl } from "../../../helpers/GetImageUrl";





const ClientPage = () => {
  const [clients, setClients] = useState([]);

  const getClients = async () => {
    try {
      const response = await http.get("/clients");
      setClients(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getClients();
  }, []);

  return (
    <main className="min-h-screen">
      <section className="px-4 sm:px-6 lg:px-8">
        <div
          className="
          max-w-[1800px]
          mx-auto
          py-16
          sm:py-20
          lg:py-28
          text-center
          "
        >
          <span
            className="
            text-blue-600
            uppercase
            tracking-[0.25em]
            sm:tracking-[0.35em]
            text-xs
            sm:text-sm
            font-bold
            "
          >
            Our Clients
          </span>

          <h1
            className="
            mt-4
            text-3xl
            sm:text-4xl
            md:text-5xl
            lg:text-6xl
            xl:text-7xl
            2xl:text-8xl
            font-black
            leading-tight
            text-slate-900
            "
          >
            Trusted by Leading Organizations
          </h1>

          <p
            className="
            mt-5
            max-w-3xl
            mx-auto
            text-sm
            sm:text-base
            md:text-lg
            lg:text-xl
            text-slate-600
            "
          >
            Across Industries and Geographies
          </p>
        </div>
      </section>

      <section
        className="
        px-4
        sm:px-6
        lg:px-8
        pb-16
        sm:pb-20
        bg-white
        py-5
        "
      >
        <div
          className="
          max-w-[1800px]
          mx-auto
          grid
          grid-cols-2
          sm:grid-cols-3
          md:grid-cols-4
          lg:grid-cols-5
          xl:grid-cols-6

          gap-5
          sm:gap-6
          lg:gap-8
          2xl:gap-10
          "
        >
          {clients.map((client) => (
            <div
              key={client._id}
              className="
    h-36
    sm:h-44
    md:h-48
    lg:h-52
    2xl:h-60
    bg-white
    rounded
    border
    border-slate-200
    shadow-sm
    flex
    items-center
    justify-center
    p-6
    sm:p-10
    2xl:p-12
    overflow-hidden
  "
            >
              <img
                src={GetImageUrl(client.image)}
                loading="lazy"
                decoding="async"
                alt="client"
                className="
      max-h-full
      max-w-full
      object-contain

      scale-105
      hover:scale-115

      transition-transform
      duration-300
    "
              />
            </div>
          ))}
        </div>

        {clients.length === 0 && (
          <div
            className="
            max-w-screen-xl
            mx-auto
            text-center
            py-20
            "
          >
            <h3
              className="
              text-xl
              sm:text-2xl
              font-bold
              text-slate-700
              "
            >
              No Clients Added Yet
            </h3>

            <p
              className="
              mt-2
              text-sm
              sm:text-base
              text-slate-500
              "
            >
              Our trusted partners will appear here soon.
            </p>
          </div>
        )}
      </section>

      <section className="px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-15">
        <div className="">
          <div
            className="
            bg-gradient-to-br from-black via-slate-900 to-blue-950
            rounded-2xl sm:rounded-3xl
            p-6 sm:p-10 lg:p-14
            text-center
            relative
            overflow-hidden
          "
          >
            <p
              className="
              text-blue-500
              uppercase
              tracking-[0.3em] sm:tracking-[0.4em]
              text-[10px] sm:text-xs
              font-black
              mb-4
            "
            >
              Contact Us
            </p>

            <h2
              className="
              text-2xl
              sm:text-4xl
              lg:text-5xl
              font-black
              uppercase
              text-white
              leading-tight
            "
            >
              Protect Your Space
              <span className="text-blue-500 block sm:inline">
                {" "}
                With Confidence
              </span>
            </h2>

            <p
              className="
              mt-5 sm:mt-6
              max-w-xl
              mx-auto
              text-slate-400
              text-xs sm:text-sm
              leading-relaxed
            "
            >
              Need CCTV installation or complete security solutions? Our experts
              are ready to help you build a safer environment.
            </p>

            <button
              onClick={() => (window.location.href = "/contact")}
              className="
              mt-7 sm:mt-8
              w-full sm:w-auto
              bg-blue-600
              hover:bg-blue-500
              text-white
              px-8 sm:px-10
              py-3 sm:py-4
              rounded-xl sm:rounded-2xl
              font-black
              uppercase
              text-[10px] sm:text-xs
              tracking-widest
              transition-all
            "
            >
              Get In Touch
            </button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ClientPage;
